import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const PORTAL_BASE = `${BACKEND_URL}/api/portal`;

export const portalApi = axios.create({ baseURL: PORTAL_BASE });
portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("portal_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const rupiah = (n) => "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export const fmtBytes = (n) => {
  const v = Number(n || 0);
  if (v >= 1e9) return (v / 1e9).toFixed(2) + " GB";
  if (v >= 1e6) return (v / 1e6).toFixed(1) + " MB";
  if (v >= 1e3) return (v / 1e3).toFixed(0) + " KB";
  return v + " B";
};

export const errMsg = (e, fallback = "Terjadi kesalahan, coba lagi") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

export const STATUS_STYLE = {
  PAID: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  UNPAID: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  PARTIAL: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  EXPIRED: "bg-slate-500/15 text-slate-300 border-slate-500/40",
  CANCELLED: "bg-slate-500/15 text-slate-400 border-slate-600/40",
};
export const STATUS_LABEL = { PAID: "LUNAS", UNPAID: "BELUM BAYAR", PARTIAL: "SEBAGIAN", EXPIRED: "KEDALUWARSA", CANCELLED: "DIBATALKAN" };
